import React, {Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';
import SmartForm from '../../../components/SmartForm';
import Validator from '../../../helpers/Validator';
import {createEmployee as APICreateEmployee} from '../../../gateways/employees';

class New extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formValues: {
        "name": "",
        "number": ""
      },
      formErrors: {},
      formAlert: {
        message: "",
        color: "",
        open: false
      }
    };

    this.form = {
      editAble: true,
      fields: [
        {
          "id": "number",
          "text": "Number",
          "type": "text"
        },
        {
          "id": "name",
          "text": "Name",
          "type": "text"
        }
      ]
    }

    this.validator = new Validator({
      validationOptions: {
        "number": ["required"],
        "name": ["required", { "type": "max", "value": 255 }]
      }
    });
  }

  setFormValue(field, value) {
    this.setState({
      "formValues": {
        ...this.state.formValues,
        [field]: value
      }
    }, () => {
      if ( this.state.formErrors[field] ) {
        let result = this.validator.validate({ [field]: this.state.formValues[field] });
        this.setFormErrors(result.messages);
      }
    });
  }

  setFormErrors(errors, callback = () => {}) {
    this.setState({
      "formErrors": {
        ...this.state.formErrors,
        ...errors
      }
    });
  }

  submitForm() {
    let result = this.validator.validate(this.state.formValues);
    let message = "";
    let color = "";
    let formErrors = {};
    if ( !result.error ) {
      APICreateEmployee(this.state.formValues).then((result) => {
        if ( result.error ) {
          message = result.msg || "Something went wrong. Please contact administrator.";
          color = "danger";
        } else {
          this.props.history.push('/employees/view/' + result.employee.id);
        }
      }).catch((error) => {
        let message = "";
        if ( error.response && error.response.data ) {
          message = error.response.data.message;
        } else {
          message = error.message;
        }

        this.setState({
          formAlert: {
            message: message,
            color: color
          },
          formErrors: result.messages
        });

      });
    } else {
      this.setFormErrors(result.messages);
    }
  }

  dismissAlert() {
    this.setState({
      formAlert: {
        color: "",
        message: ""
      }
    });
  }

  render() {
    return (
      <Row>
        <Col xs="12" lg="8">
          <SmartForm
            form={this.form}
            formValues={this.state.formValues}
            formErrors={this.state.formErrors}
            onSetFormValue={(field, value) => this.setFormValue(field, value)}
            onSubmit={() => this.submitForm()}
            onAlertDismiss={() => this.dismissAlert()}
            alert={this.state.formAlert} />
        </Col>
      </Row>
    );
  }

}

export default New;


// WEBPACK FOOTER //
// ./src/views/Employee/EmployeeNew/New.js